var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPowerpointSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6105 3.43842H13.683V22.5616H24.6105C24.9882 22.5616 25.2935 22.2563 25.2935 21.8786V4.12139C25.2935 3.7437 24.9882 3.43842 24.6105 3.43842Z",
    fill: "#FF8A65"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16.4149H22.5616V17.7808H13V16.4149ZM13 19.1468H22.5616V20.5127H13V19.1468ZM17.0978 6.85327C14.8351 6.85327 13 8.68841 13 10.9511C13 13.2138 14.8351 15.0489 17.0978 15.0489C19.3605 15.0489 21.1957 13.2138 21.1957 10.9511H17.0978V6.85327Z",
    fill: "#FBE9E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4638 5.4873V9.58513H22.5616C22.5616 7.32245 20.7265 5.4873 18.4638 5.4873Z",
    fill: "#FBE9E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0489 25.2935L0.706528 22.5616V3.4384L15.0489 0.706512V25.2935Z",
    fill: "#E64A19"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10174 8.21921H4.80435V17.7808H6.85327V14.4868H7.91324C9.04355 14.4868 9.94576 14.1891 10.6212 13.5962C11.296 13.0027 11.6347 12.2255 11.6334 11.2659C11.6341 9.23479 10.4559 8.21921 8.10174 8.21921ZM7.73703 12.8532H6.85327V9.87268H7.73703C8.85779 9.87268 9.41782 10.3644 9.41782 11.3465C9.41782 12.3519 8.85779 12.8532 7.73703 12.8532Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerpointSmall);
export default __webpack_public_path__ + "static/media/powerpoint_small.46669f71671ae92dc441e3242037d241.svg";
export { ForwardRef as ReactComponent };